import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import './ExternalLinkModal.css';

interface ExternalLinkModalProps {
  isOpen: boolean;
  url: string;
  onClose: () => void;
}

const SESSION_SKIP_KEY = 'skipExternalLinkConfirm';

export function shouldSkipExternalLinkConfirm(): boolean {
  return sessionStorage.getItem(SESSION_SKIP_KEY) === 'true';
}

export const ExternalLinkModal: React.FC<ExternalLinkModalProps> = ({
  isOpen,
  url,
  onClose,
}) => {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  if (!isOpen) return null;

  const handleContinue = () => {
    if (dontAskAgain) {
      sessionStorage.setItem(SESSION_SKIP_KEY, 'true');
    }
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const content = (
    <div className="external-link-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="external-link-modal">
        <div className="external-link-modal-header">
          <h2>Hold up!</h2>
        </div>

        <div className="external-link-modal-content">
          <p>You're about to leave TradeMagic and visit an external site:</p>
          <div className="external-link-modal-url">{url}</div>
          <label className="external-link-modal-checkbox-label">
            <input
              type="checkbox"
              checked={dontAskAgain}
              onChange={(e) => setDontAskAgain(e.target.checked)}
            />
            <span>Don't ask me again for this session</span>
          </label>
        </div>

        <div className="external-link-modal-footer">
          <MagicButton
            label="No, take me back"
            color="purple"
            onPress={onClose}
          />
          <MagicButton
            label="Yes, continue"
            color="dark-grey"
            onPress={handleContinue}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default ExternalLinkModal;
